exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn.disabled,.btn:disabled{opacity:.8}.swal2-toast .swal2-actions button.swal2-confirm{font-size:12px}", ""]);

// exports
